import { FC, ReactNode } from 'react';
import {
  QUOTE_FIELD_ANCHOR_SX,
  QUOTE_FIELD_ATTRIBUTE,
  QuoteFieldKey,
} from '../../utils/quoteFieldValidations';
import { MBox } from '../Monetize';
import { QuoteFieldValidations } from './QuoteFieldValidations';

interface QuoteFieldAnchorProps {
  /**
   * Every field key this anchor hosts. Scroll, highlight and "Jump to" all
   * resolve against it, and a rule targeting any of them renders its message
   * below `children`.
   */
  fieldKey: QuoteFieldKey | readonly QuoteFieldKey[];
  children: ReactNode;
}

/**
 * The one way a quote field opts into rule validations: it hangs the anchor
 * attribute the alerts panel scrolls to, and renders that field's messages
 * inline beneath it.
 */
export const QuoteFieldAnchor: FC<QuoteFieldAnchorProps> = ({
  fieldKey,
  children,
}) => {
  const fieldKeys = typeof fieldKey === 'string' ? [fieldKey] : fieldKey;

  return (
    <MBox
      {...{ [QUOTE_FIELD_ATTRIBUTE]: fieldKeys.join(' ') }}
      css={QUOTE_FIELD_ANCHOR_SX}
    >
      {children}
      <QuoteFieldValidations fieldKeys={fieldKeys} />
    </MBox>
  );
};
